<ng-container>
    <div class="d-flex justify-content-between align-items-center my-2">
        <div class="card-sub-heading bold">Update Status</div>
        <button mat-icon-button (click)="closeDialog()" [disabled]="isLoading" type="button">
            <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
        </button>
    </div>
    <div class="row">
        <div class="col-md-12 mb-4">
            Are you sure you want to update the status?
        </div>
        <div class="col-md-12 d-flex dcp">
            <button class="btn btn-outline-primary mr-3 w-50" (click)="closeDialog()" mat-dialog-close
                [disabled]="isLoading">Cancel</button>
            <button class="btn btn-primary w-50" (click)="submitForm()" [disabled]="isLoading">
                {{ isLoading ? 'Confirming...' : 'Confirm' }}
            </button>
        </div>
    </div>
</ng-container>